import request from '@/utils/request'
/**
 * 获取当前用户的机构树
 */
export function getMyDeptTree() {
  return request({
    baseURL: process.env.VUE_APP_System_Api,
    url: '/api/organization/list',
    method: 'get'
  })
}

/**
 * 获取站点的机构树
 */
export function getWebSiteDeptTree(data) {
  return request({
    baseURL: process.env.VUE_APP_System_Api,
    url: '/api/organization/websitetree',
    method: 'get',
    params: data
  })
}


/**
 * 获取站点的机构树
 */
export function getMineDeptTree() {
  return request({
    baseURL: process.env.VUE_APP_System_Api,
    url: '/api/organization/tree2',
    method: 'get',
  })
}

/**
 * 获取当前用户的公司（子公司）的组织机构
 * @param {search} data 
 */
export function GetAuthOrgan() {
  return request({
    baseURL: process.env.VUE_APP_Dzy,
    url: '/api/Tool/GetAuthOrgan',
    method: 'get'
  })
}


/**
 * 获取所有的组织机构
 * @param {search} data 
 */
export function GetALLOrgan() {
  return request({
    baseURL: process.env.VUE_APP_Dzy,
    url: '/api/Tool/GetALLOrgan',
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/organization.js